export default "https://cdn-static.gokick.com/assets/eeaee1442152ca0221916151b947444cbee5198d/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";